import { render } from "./agregarNota.vue?vue&type=template&id=6d2a885c&scoped=true"
import script from "./agregarNota.vue?vue&type=script&lang=js"
export * from "./agregarNota.vue?vue&type=script&lang=js"

import "./agregarNota.vue?vue&type=style&index=0&id=6d2a885c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2a885c"]])

export default __exports__